import React, { useCallback, useRef, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Layout, Button, Input, Select } from '../../../components';
import SelectType from '../../../components/Form/Select/select_type';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { InstructionDataDTO } from '../../../shared/interfaces/instructions';
import type { ScreenData } from '../../../shared/interfaces/screen';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Container, FormContainer, FormFooter } from './styles';

const Cadastro: React.FC = () => {
  const formRef = useRef<FormHandles | null>(null);
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToast();

  const [dataTable, setDataTable] = useState<SelectType[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let selectedScreens = useRef<number[] | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const response = await api.get<ScreenData[]>(`/tela`);

      let screenValues: SelectType[] = response.data.map(
        (screen: ScreenData) => {
          return {
            value: screen.id,
            label: screen.titulo,
          };
        },
      );

      setDataTable(screenValues);
    } catch (e) {
      console.error(e);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  function back() {
    if (location.pathname.match('/listar')) {
      history.push(RoutesPaths.home);
    } else {
      history.goBack();
    }
  }

  const handleSubmit = useCallback(
    async (data: InstructionDataDTO) => {
      setIsLoading(true);
      data.listaDeTelas = selectedScreens.current;

      try {
        if (!data.listaDeTelas?.length) {
          const schemaSelect = Yup.object().shape({
            id: Yup.string().max(25, 'No máximo 25 caracteres'),
            nomeDaInstrucao: Yup.string()
              .max(40, 'No máximo 40 caracteres')
              .matches(
                /^(?!\s*$)[-a-zA-Z0-9_:,.' ']/,
                'Um ou mais caracteres digitados não são permitidos!',
              )
              .required('Este campo é obrigatório!'),
            textoDaInstrucao: Yup.string()
              .max(200, 'No máximo 200 caracteres')
              .matches(
                /^(?!\s*$)[-a-zA-Z0-9_:,.' ']/,
                'Um ou mais caracteres digitados não são permitidos!',
              )
              .required('Este campo é obrigatório!'),
            select: Yup.string().required('Este campo é obrigatório!'),
          });
          await schemaSelect.validate(data, {
            abortEarly: false,
          });
        }
        const schema = Yup.object().shape({
          id: Yup.string().max(25, 'No máximo 25 caracteres'),
          nomeDaInstrucao: Yup.string()
            .max(40, 'No máximo 40 caracteres')
            .matches(
              /^(?!\s*$)[-a-zA-Z0-9_:,.' ']/,
              'Um ou mais caracteres digitados não são permitidos!',
            )
            .required('Este campo é obrigatório!'),
          textoDaInstrucao: Yup.string()
            .max(200, 'No máximo 200 caracteres')
            .matches(
              /^(?!\s*$)[-a-zA-Z0-9_:,.' ']/,
              'Um ou mais caracteres digitados não são permitidos!',
            )
            .required('Este campo é obrigatório!'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/instrucao', data);
        setIsLoading(false);

        addToast({
          type: 'success',
          title: 'Instrução cadastrada com sucesso!',
          description:
            'As informações da Instrução foram cadastradas. Você pode verificar a nova Instrução na seção de Listagem de Instruções.',
        });

        setTimeout(() => {
          history.push(RoutesPaths.listInstruction);
        }, 4000);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errorMessages = getValidationErrors(err);
          formRef.current?.setErrors(errorMessages);
          return;
        } else {
          console.error(err);
          addToast({
            type: 'error',
            title: 'Instrução já cadastrada!',
            description:
              'As informações que foram inseridas, já estão presentes no sistema.',
          });
        }
      }
    },
    [addToast, history],
  );

  function handleScreenChange(dataTable: [] | null) {
    if (dataTable) {
      const valor = dataTable.map((item: any) => item['value']);
      selectedScreens.current = valor;
    }
  }

  return (
    <>
      <Layout title={'Cadastro de Instruções'} hideFloatingButton>
        <Container>
          <FormContainer>
            <Form
              data-testid={'form'}
              className="form-container"
              ref={formRef}
              onSubmit={handleSubmit}
            >
              <Input
                name="nomeDaInstrucao"
                label="Nome"
                type="text"
                data-testid={'input-name'}
              />
              <Input
                name="textoDaInstrucao"
                label="Texto"
                type="text"
                data-testid={'input-text'}
              />

              <Select
                name={'select'}
                options={dataTable}
                onChange={handleScreenChange}
                placeholder="Selecione"
                label="Telas"
                loading={!dataTable.length}
              />

              <FormFooter>
                <Button
                  variant="solid"
                  style={{ marginTop: '1rem' }}
                  type="submit"
                >
                  Adicionar
                </Button>
                <Button
                  variant="outline"
                  color={'#C71F37'}
                  style={{ marginTop: '1rem' }}
                  onClick={() =>
                    setTimeout(() => {
                      back();
                    }, 500)
                  }
                >
                  Cancelar
                </Button>
              </FormFooter>
            </Form>
          </FormContainer>
        </Container>
      </Layout>
    </>
  );
};

export default Cadastro;
